<ng-container *ngIf="(canViewCompanySettings$ | async)?.can">
  <section id="other">
    <app-company-settings-other></app-company-settings-other>
  </section>
</ng-container>
